module.exports = __webpack_public_path__ + "img/vol01_cup01_badge.225398d1.png";